// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"EditCategoryModalContent_modal-wrapper__o1UKA"};